<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="审视计划" prop="surveyId">
              <el-select placeholder="请选择审视计划" v-model="formParameter.surveyId" @change="chgSurvey">
                <el-option v-for="item in surveys" :key="item.id" :label="item.modeName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="bug数量" prop="bugcnt"><el-input v-model="formParameter.bugcnt" :placeholder="'数值类型'"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="审视结论" prop="conclusion">
              <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.conclusion"></wang-edit>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="审视需求" prop="conclusion">
              <div v-for="(itm, idx) in pgoalArr" :key="idx + 1000">
                <el-checkbox>{{ itm }}</el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--图片上传-->
          <el-col :span="24">
            <el-form-item label="审视截图" prop="simg">
              <el-upload :action="uploadUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove" multiple :limit="3" :headers="headers" :on-success="handleSuccessed"
                v-model="formParameter.imgUrl" ref="up">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/sprint/survey_record/survey_record.js";
import apiSurvey from "@/api/sprint/survey/survey.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import constant from "@/util/constant.js";


export default {
  name: "edit",
  components: {
    popup,
    wangEdit,
  },
  data() {
    return {
      headers: { jwttoken: localStorage.getItem("jwttoken") }, //本地获取
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {

      },
      isUpdtWedit: false, //用于更新wangEdit
      sprId: "",
      pgoalArr: [],
      surveys: [], //查询本sprint下状态为 进行中 的审视计划
      rules: {
        //sprintBacklogId,待办id
        sblId: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //审视id
        surveyId: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //待办审视出来的bug数量
        bugcnt: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.range,
            min: "0",
            trigger: "blur",
          },
          {
            validator: this.$validate.number,
            trigger: "blur",
          },
        ],
      },
      fileList: [],
      uploadUrl: "",
      imgUrl: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  methods: {

    chgSurvey() {
      console.log("sbl_id= ", this.parameter.sprintbacklogId, "survey_id = ", this.formParameter.surveyId)

      api.getBySBLIDandSurRecordID({ sblId: this.parameter.sprintbacklogId, surveyId: this.formParameter.surveyId }, res => {

        this.isUpdtWedit = true;
        this.formParameter = res.data

        setTimeout(() => {
          this.isUpdtWedit = false;
        }, 100);


         //  console.log(" this.formParameter", this.formParameter)
      }, err => {
        //this.$utils.msg.warning(err.msg);
      })

    },
    //查询状态为进行中的审视计划
    getGoingSurvey() {
      apiSurvey.getGoingSurveyBySprId({ sprId: this.sprId }, (res) => {
        this.surveys = res.data;
      });
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.pgoalArr = [];
      if (this.parameter.pgoal && this.parameter.pgoal.length > 1) {
        let arr = this.parameter.pgoal.split("</p>");
        let tmpArr = [];
        arr.forEach((v) => {
          //处理<p>
          let str = v.trim().replace("<p>", "");
          if (str.length > 2) {
            tmpArr.push(str);
          }
        });

        tmpArr.forEach((v2) => {
          //处理</br>

          let str2 = v2.split("<br/>");
          str2.forEach((v3) => {
            if (v3.length > 2) {
              // 去掉html标签                // 去掉空格转义
              this.pgoalArr.push(
                v3.replace(/<[^>]+>/g, "").replaceAll("&nbsp;", "")
              );
            }
          });
        });
      }
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },

    //关闭弹框
    close() {
      this.disabled = false;
      this.formParameter = {};
      //清空旧值
      this.isUpdtWedit = true;
      setTimeout(() => {
        this.isUpdtWedit = false;
      }, 100);
      this.$refs.popup.close();
      this.$refs.up.clearFiles();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {

        this.confirmLoading = true;
        if (!this.formParameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          console.log(parameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.uploadUrl =
        constant.serverUrl + "/surveyRecord/surveyRecord/uploadImg";
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;

          if (this.formParameter.conclusion) {
            this.isUpdtWedit = true;
            setTimeout(() => {
              this.isUpdtWedit = false;
            }, 100);
          }

          this.popupLoading = false;
        });
      } else {
        //添加

        this.formParameter.sblId = this.parameter.sprintbacklogId;
        this.sprId = this.parameter.sprId;

        //查询本sprint下状态为 进行中 的审视计划
        this.getGoingSurvey();

        this.popupLoading = false;
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    //删除之前执行的方法
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除${file.name}吗?`);
    },
    //文件删除的方法
    handleRemove(file, fileList) {
      //此处elementui会自动去掉删除的图片，fileList数组会自动清楚删除的图片的地址
      //所以fileList就是删除成功之后的数组，不需要在进行任何处理
      console.log(file, fileList);
      this.fileList = fileList;
    },
    /* 上传 */
    handleSuccessed(res, file) {
      this.imgUrl.push(res.data);

      this.$set(this.formParameter, 'imgUrl', this.imgUrl);
      console.log(this.formParameter.imgUrl);
      // api.uploadImg(parameter,(response)=>{
      //   console.log("请求成功");
      // });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },

};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>